import DitapPopup from "./DitapPopup";
import DitapMask from "./DitapMask";
import AlertButtonType from "../const/AlertButtonType";
/**
 * 다이탭 알림창 클래스.</br>
 * Ditap alert class.
 * @extends DitapPopup
 *
 * @alias DitapAlert
 * @constructor
 *
 * @param {object} obj 각각 다음과 같은 속성을 가진 객체.<br> Object with the following properties:
 * @param {string} obj.type 아이콘 타입("success", "warning", "error", "info", "question").</br> Icon type ("success", "warning", "error", "info", "question").
 * @param {string} obj.title 제목.</br> Title.
 * @param {string} obj.content1 첫번째 내용.</br> First content.
 * @param {string} obj.content2 두번째 내용.</br> Second content.
 * @param {string} obj.buttons 버튼 종류("OKANDCANCEL", "ONLYOK", "NOBUTTONS").</br> Button type ("OKANDCANCEL", "ONLYOK", "NOBUTTONS").
 * @param {boolean} [obj.open=true] 알림창 즉시 표시 여부.</br> Display notification window immediately.
 * @param {boolean} [obj.mask=true] 배경 마스크 표시 여부.</br> Background mask.
 * @param {Function} obj.callback 확인 버튼 클릭 시 실행 함수.</br> OK Button click callback.
 *
 * @example
 * const props = {
 *  type : "info",
 *  title : "정보",
 *  content1 : "정보 관련 텍스트입니다.",
 *  content2 : "정보 관련 텍스트 내용을 입력해주세요",
 *  buttons : "OKANDCANCEL",
 *  callback: () => { funcAfterClick(); },
 *  closeCallback: (alert) => { alert.destroy(); },
 *  open: false
 * }
 *
 * const alert = new Ditap.DitapAlert(props);
 */
class DitapAlert extends DitapPopup {
  constructor(props) {
    //부모
    const parent = document.querySelector("body");
    super(parent);

    if (props.open === undefined) {
      props.open = true;
    }

    if (props.mask === undefined) {
      props.mask = true;
    }

    // 마스크 인스턴스 저장
    if (props.mask) {
      this._mask = new DitapMask();
    }

    // 버튼 형태 값
    this._buttons = props.buttons;

    //버튼
    this._alertOkBtn = undefined;
    this._alertCloseBtn = undefined;

    // 콜백 함수
    this._callback =
      typeof props.callback === "function" ? props.callback : () => {};

    //생성
    const alrertBox = this.createAlertBox(props);

    // // 컨텐츠 추가
    this.appendContent(alrertBox["content"]["contentImg"]);
    this.appendContent(alrertBox["content"]["contentTitle"]);
    this.appendContent(alrertBox["content"]["contentBox"]);
    // this.appendContent(alrertBox["content"]["cotent1"]);
    // this.appendContent(alrertBox["content"]["cotent2"]);

    // // 푸터 추가
    this.appendFooter(alrertBox["footer"]["footerBox"]);

    // 확인 버튼 바인딩
    this.bindCallbackOkBtn();

    // 취소 콜백 함수
    if (props.closeCallback) {
      this._closeCallback =
        typeof props.closeCallback === "function"
          ? props.closeCallback
          : () => {};

      // 취소 버튼 바인딩
      this.bindCallbackCloseBtn();
    }

    //팝업창 열기
    if (props.open) {
      this.open();
    }

    // this.disableDrag();
  }

  /*
   * 알림창 하단에 버튼 표시 타입.</br>
   * Button display type at the bottom of the notification window.
   * @type {string}
   */
  get buttons() {
    return this._buttons;
  }

  set buttons(buttons) {
    this._buttons = buttons;
  }

  /*
   * 알림창에서 확인 버튼 클릭 시 실행 할 함수.</br>
   * Callback function to be executed when the notification window OK button is clicked.
   * @type {Function}
   */
  get callback() {
    return this._callback;
  }

  set callback(callback) {
    this._callback = callback;
  }

  /*
   * 알림창에서 취소 버튼 클릭 시 실행 할 함수.</br>
   * Callback function to be executed when the notification window CLOSE button is clicked.
   * @type {Function}
   */
  get closeCallback() {
    return this._closeCallback;
  }

  set closeCallback(closeCallback) {
    this._closeCallback = closeCallback;
  }

  /*
   * 확인 버튼 요소.</br>
   * OK button element.
   * @type {Element}
   */
  get alertOkBtn() {
    return this._alertOkBtn;
  }

  set alertOkBtn(alertOkBtn) {
    this._alertOkBtn = alertOkBtn;
  }

  /*
   * 취소 버튼 요소.</br>
   * Close button element.
   * @type {Element}
   */
  get alertCloseBtn() {
    return this._alertCloseBtn;
  }

  set alertCloseBtn(alertCloseBtn) {
    this._alertCloseBtn = alertCloseBtn;
  }

  /*
   * 다이탭 마스크 인스턴스.</br>
   * DitapMask instance.
   * @type {DitapMask}
   */
  get mask() {
    return this._mask;
  }
  set mask(mask) {
    this._mask = mask;
  }

  /*
   * 알림창 양식 생성.</br>
   * Create notification window form.
   * @private
   * @param {object} props 다음과 같은 속성을 가진 객체: Object with the following properties:
   * @param {string} props.type 아이콘 타입.</br> Icon type "success", "warning", "error", "info", "question".
   * @param {string} props.title 제목.</br> Title
   * @param {string} props.content1 첫번째 내용.</br> First content.
   * @param {string} props.content2 두번째 내용.</br> Second content.
   * @param {string} props.buttons 버튼 종류.</br> Button state "OKANDCANCEL", "ONLYOK", "NOBUTTONS".
   * @returns {object} 생성된 알림창 요소.</br> Created Alert element.
   */
  createAlertBox(props) {
    //wrapper
    this.wrapper.classList.add("ditap-alert-popup");

    //content
    const contentImg = document.createElement("p");
    const contentTitle = document.createElement("p");
    const contentBox = document.createElement("div");

    contentBox.classList.add("ditap-alert-content");
    contentImg.classList.add(
      "ditap-alert-img",
      `ditap-alert-${props.type}-img`
    );
    contentTitle.classList.add("ditap-alert-title");

    contentTitle.innerText = props.title;

    if (props.content1) {
      const content1 = document.createElement("p");
      content1.classList.add("ditap-padding-reset");
      content1.innerText = props.content1;
      contentBox.append(content1);
    }

    if (props.content2) {
      const content2 = document.createElement("p");
      content2.classList.add("ditap-padding-reset");
      content2.innerText = props.content2;
      contentBox.append(content2);
    }

    const footerBox = document.createElement("div");
    if (
      props.buttons === AlertButtonType.OKANDCANCEL ||
      props.buttons === AlertButtonType.ONLYOK
    ) {
      //footer
      footerBox.classList.add("ditap-btn-wrap");

      const footerOkBtn = document.createElement("button");
      if (props.buttons === AlertButtonType.OKANDCANCEL) {
        const footerCloseBtn = document.createElement("button");
        footerCloseBtn.classList.add("ditap-popup-btn");
        footerCloseBtn.innerText = "취소";
        footerBox.append(footerCloseBtn);
        this.alertCloseBtn = footerCloseBtn;

        //닫기 버튼
        this.alertCloseBtn.addEventListener("click", () => {
          this.close();
        });
      }

      footerOkBtn.classList.add("ditap-popup-btn", "gold");
      footerOkBtn.innerText = "확인";
      footerBox.append(footerOkBtn);
      this.alertOkBtn = footerOkBtn;
    }

    return {
      content: {
        contentImg: contentImg,
        contentTitle: contentTitle,
        contentBox: contentBox,
        // content1: content1,
        // content2: content2,
      },
      footer: {
        footerBox: footerBox,
        // footerOkBtn: footerOkBtn,
        // footerCloseBtn: footerCloseBtn,
      },
    };
  }

  /*
   * 바인딩 된 콜백 함수 제거.</br>
   * Remove bound callback.
   */
  removeCallback() {
    if (typeof this.callback === "function") {
      this.alertOkBtn.removeEventListener("click", () => {
        this.callback(this);
        this.close();
      });
    } else {
      this.alertOkBtn.removeEventListener("click", () => {
        this.close();
      });
    }
  }

  /*
   * 바인딩 된 취소 콜백 함수 제거.</br>
   * Remove bound close callback.
   */
  removeCloseCallback() {
    if (typeof this.closeCallback === "function") {
      this.alertCloseBtn.removeEventListener("click", () => {
        this.closeCallback(this);
        this.close();
      });
    } else {
      this.alertCloseBtn.removeEventListener("click", () => {
        this.close();
      });
    }
  }

  /*
   * 콜백 함수 바인딩.</br>
   * Callback binding.
   */
  bindCallbackOkBtn() {
    //새로운 콜백 맵핑
    if (
      this.buttons === AlertButtonType.OKANDCANCEL ||
      this.buttons === AlertButtonType.ONLYOK
    ) {
      if (typeof this.callback === "function") {
        this.alertOkBtn.addEventListener("click", () => {
          this.callback(this);
          this.close();
        });
      } else {
        this.alertOkBtn.addEventListener("click", () => {
          this.close();
        });
      }
    }
  }

  /*
   * 취소 콜백 함수 바인딩.</br>
   * Close callback binding.
   */
  bindCallbackCloseBtn() {
    //새로운 콜백 맵핑
    if (this.buttons === AlertButtonType.OKANDCANCEL) {
      if (typeof this.closeCallback === "function") {
        this.alertCloseBtn.addEventListener("click", () => {
          this.closeCallback(this);
          this.close();
        });
      } else {
        this.alertCloseBtn.addEventListener("click", () => {
          this.close();
        });
      }
    }
  }

  /**
   * 알림창 오픈.</br>
   * Open alert.
   */
  open() {
    super.open();
    if (this.mask) {
      this.mask.open();
    }
  }

  /**
   * 알림창 닫기.</br>
   * Close alert.
   */
  close() {
    super.close();
    if (this.mask) {
      this.mask.close();
    }
  }

  /**
   * 알림 창 파괴.</br>
   * Destroy alert.
   */
  destroy() {
    super.destroy();
    this.removeCallback();
    if (this.alertCloseBtn) {
      this.removeCloseCallback();
    }
    if (this.mask) {
      this.mask.close();
    }
  }
}

export default DitapAlert;
